import { Movax } from './Movax';

var $ = require('jquery');

/**
 * CoveringImage - Mimic the background image size cover with img tag
 * When container has no dimensions we display the image normally
 * @class
 */
export class CoveringImage {
  private $img;
  private $imgWrapper;
  private $heightTestWrapper;
  private $container;
  private jsBlock;
  private aspectRatio;
  private originalImageDimensions;
  private CHECK_CONTAINER_DIMENSIONS_INTERVAL_TIME = 100;
  private containerWidth;
  private containerHeight;

  /**
   * Constructor
   * @param {HTMLElement} private img [image element]
   * @param {string}      private block   [css block]
   * @param {number}      private minimumWrapperHeight [if below this value, display img tag normally]
   */

  constructor(private img: HTMLElement, private block: string, private minimumWrapperHeight:number) {
    this.$img = $(img);
    this.jsBlock = 'js-' + block;
  }

  private _resizeImage() {
    var self = this,
        wrapperWidth = this.$imgWrapper.outerWidth(),
        wrapperHeight = this.$imgWrapper.outerHeight(),
        wrapperAspectRatio = wrapperWidth / wrapperHeight,
        longerSideWidth = wrapperWidth > wrapperHeight ? wrapperWidth : wrapperHeight,
        heightTestWrapperHeight;

    // height test
    this.$img.detach();
    heightTestWrapperHeight = this.$heightTestWrapper.outerHeight();
    this.$img.appendTo(this.$imgWrapper);

    this.containerHeight = wrapperHeight;
    this.containerWidth = wrapperWidth;

    // Revert back to normal image when wrapperheight is smaller
    if (heightTestWrapperHeight < this.minimumWrapperHeight) {
      //(this.$img.attr('style', '');
      this.$imgWrapper.css('position', 'static');
      this.$img.css({ 'height': '', 'width':'100%', 'top': '', 'margin-top':'', 'margin-left':'' });

      if (this.$imgWrapper.hasClass(this.block + '__img-wrapper--active')) {
        this.$imgWrapper.removeClass(this.block + '__img-wrapper--active');
      }

      // And mimic background cover when minimum height is reached
    } else {

      this.$imgWrapper.css('position', 'absolute');
      if (!this.$imgWrapper.hasClass(this.block + '__img-wrapper--active')) {
        this.$imgWrapper.addClass(this.block + '__img-wrapper--active');
      }

      // reset
      this.$img.css({ 'margin-left': '', 'margin-top': '', 'left': '', 'top': '' });

      if (wrapperAspectRatio > this.aspectRatio) {
        this.$img.css({ 'left': 0, 'margin-top': - ((wrapperWidth / this.aspectRatio) / 2) + 'px' });
        this.$img.css({ 'width': wrapperWidth + 'px', 'height': wrapperWidth / this.aspectRatio + 'px' });
      } else {
        this.$img.css({ 'top': 0, 'margin-left': - ((this.aspectRatio * wrapperHeight) / 2) + 'px' });
        this.$img.css({ 'width': this.aspectRatio * wrapperHeight + 'px', 'height': wrapperHeight + 'px' });
      }
      /*
      console.log('--');
      console.log(this.aspectRatio);
      console.log(wrapperAspectRatio);
      console.log('--');*/
    }
  }

  private _checkContainerDimensions() {
    var width, height;

    if(this.$imgWrapper && this.$imgWrapper.length) {
      width = this.$imgWrapper.outerWidth();
      height = this.$imgWrapper.outerHeight();

      if (this.containerWidth !== width || this.containerHeight !== height) {
        this.containerWidth = width;
        this.containerHeight = height;
        this._resizeImage();
      }
    }
  }

  private _updateImageDimensions(width?, height?) {
    this.originalImageDimensions = {
      'width': width || this.$img.width(),
      'height': height || this.$img.height()
    };

    this.aspectRatio = this.originalImageDimensions.width / this.originalImageDimensions.height;
  }

  private _startCovering() {
    var self = this,
        containerPosition;

    this.$container = this.$img.parent();
    this.$imgWrapper = $('<div class="' + this.block + '__img-wrapper"></div>');
    this.$heightTestWrapper = $('<div class="' + this.block + '__height-test"></div>');

    this.$imgWrapper.insertBefore(this.$img);
    this.$imgWrapper.append(this.$img);
    this.$imgWrapper.append(this.$heightTestWrapper);

    this.$img.show();
    this.$img.addClass(this.block + '__img');

    containerPosition = this.$container.css('position');

    if (!containerPosition || containerPosition === 'static') {
      this.$container.css({ 'position': 'relative' });
    }

    this.$img.addClass(this.jsBlock + '--loaded');

    Movax.dom.waitForClass(this.block + '__img', this.$img[0]).then(function() {
      self.$img.addClass(self.block + '__img--loaded');
      /*setTimeout(function () {

      }, 200);*/

    });

    // Once styles have been applied, it's time to trigger first resize
    Movax.dom.waitForStyles(this.$imgWrapper[0], { 'position': 'absolute' }).then(function() {

      // Initial resize
      self._resizeImage();
    });

    // Resize image when layout changes
    Movax.events.addResizeSubscriber(function() {
      self._resizeImage();
    });
  }

  public init() {
    var self = this,
        loaded = false,
        imageInfoInterval;

    if (!this.$img.length) {
      return;
    }

    //this.$img.hide();

    this.img.onload = function() {
      self._updateImageDimensions(self.$img.width(), self.$img.height());
    }

    imageInfoInterval = setInterval(function () {
      var width = self.$img.width(),
          height = self.$img.height();

      if(width > 20 && height > 20) {

        clearInterval(imageInfoInterval);
        self._updateImageDimensions(width, height);
        self._startCovering();
      }
    }, 50);

    setInterval(function() {
      self._checkContainerDimensions();
    }, this.CHECK_CONTAINER_DIMENSIONS_INTERVAL_TIME);
  }
}
